module.exports = __webpack_public_path__ + "img/chair-office.f07cf2bd.svg";